<div class="d-flex flex-row">
  <div class="max-width-300 d-flex  flex-column mg-r-15">
    <div>
      <h3 class="first">Période</h3>
      <yo-periode-lookup
        [periodeList]="periodes"
        [selectedPeriodeId]="selectedPeriode?.id"
        (onPeriodeChange)="onPeriodeChange($event)">
      </yo-periode-lookup>
    </div>

    <div class="mg-t-15 d-flex flex-column plc-list-wrapper">
      <yo-plc-list
        title="Points de livraison"
        [plcList]="pointsDeLivraison"
        [selectedPlcId]="selectedPointDeLivraison?.id"
        [contratMenuConvive]="contratMenuConvive"
        (onPlcChange)="onPlcChange($event)"
        (onPlcListChange)="onPlcListChange($event)">
      </yo-plc-list>
    </div>
  </div>

  <div class="table-width-size">
    <!--          afficher le parametrage du point de livraison-->
    <router-outlet></router-outlet>
  </div>

</div>
